import {logger} from './logger';

function checkLocalStorageAvailable() {
  let storage = window.localStorage;
  try {
    let x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return e instanceof DOMException && (
        // everything except Firefox
      e.code === 22 ||
      // Firefox
      e.code === 1014 ||
      // test name field too, because code might not be present
      // everything except Firefox
      e.name === 'QuotaExceededError' ||
      // Firefox
      e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage.length !== 0;
  }
}

let localStorageAvailable = checkLocalStorageAvailable();

function loadFromLocalStorage<T>(key: string) {
  let json: string | null;

  try {
    json = window.localStorage.getItem(key);
  } catch (e) {
    logger.error('loadFromLocalStorage: unable to get item from local storage',
      {key: key, exception: e});
    return null;
  }

  try {
    if (json !== null)
      return JSON.parse(json) as T;
  } catch (e) {
    logger.error('loadFromLocalStorage: unable to parse JSON',
      {key: key, json: json, exception: e});
  }

  return null;
}

let loadFromLocalStorageImpl: typeof loadFromLocalStorage;
if (localStorageAvailable)
  loadFromLocalStorageImpl = loadFromLocalStorage;
else
  loadFromLocalStorageImpl = () => null;

function saveToLocalStorage<T>(key: string, value: T) {
  if (value === null || value === undefined)
    return;

  let json: string;

  try {
    json = JSON.stringify(value);
  } catch (e) {
    logger.error('saveToLocalStorage: unable to stringify value to JSON',
      {key: key, value: value, exception: e});
    return;
  }
  try {
    window.localStorage.setItem(key, json);
  } catch (e) {
    logger.error('saveToLocalStorage: unable to set item',
      {key: key, json: json, exception: e});
  }
}

let saveToLocalStorageImpl: typeof saveToLocalStorage;
if (localStorageAvailable)
  saveToLocalStorageImpl = saveToLocalStorage;
else
  saveToLocalStorageImpl = () => {
  };

function removeFromLocalStorage(key: string) {
  try {
    window.localStorage.removeItem(key);
  } catch (e) {
    logger.error('removeFromLocalStorage: unable to remove',
      {key: key, exception: e});
  }
}

let removeFromLocalStorageImpl: typeof removeFromLocalStorage;
if (localStorageAvailable)
  removeFromLocalStorageImpl = removeFromLocalStorage;
else
  removeFromLocalStorageImpl = () => {
  };

class LocalStorageUtils {
  readonly load = loadFromLocalStorageImpl;
  readonly save = saveToLocalStorageImpl;
  readonly remove = removeFromLocalStorageImpl;
}

export const localStorageUtils = new LocalStorageUtils();
